import { UseComparisons } from '@dustin-web/microsite-data/src/hooks/use-comparisons-internal'
import { useDataLoaderHooks } from './use-dataloader-hooks'
export type { ComparisonProductList } from '@dustin-web/microsite-data/src/hooks/use-comparisons-internal'

export const useComparisons: UseComparisons = () => {
  const { compare } = useDataLoaderHooks()

  return (
    compare() || {
      data: null,
      error: null,
      loading: true,
      updateComparisons: () => {},
      comparisonsLists: [],
    }
  )
}
